export enum ErrorMessage {
    NonUniqueProperties = 'NON_UNIQUE_PROPERTIES',
    NonUniquePackingUnitQuantity = 'NON_UNIQUE_PACKING_UNIT_QUANTITY',
    CannotDeleteClassification = 'CANNOT_DELETE_CLASSIFICATION',
    ContactIsAssignedToBonusCondition = 'CONTACT_IS_ASSIGNED_TO_BONUS_CONDITION',
    ContactIsAssignedAsMainContact = 'CONTACT_IS_ASSIGNED_AS_MAIN_CONTACT',
}
